import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const ProductCard = ({ product, style }) => {
  const [imgSrc, setImgSrc] = useState(null);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    let initialImage = product.image || (product.originalData ? product.originalData.image_url : null);

    if (initialImage) {
      if (initialImage.startsWith('http://')) {
         initialImage = `https://wsrv.nl/?url=${encodeURIComponent(initialImage)}&output=png`;
      }
      setImgSrc(initialImage);
      setHasError(false);
    } else {
      setImgSrc(null);
      setHasError(true); 
    }
  }, [product]);

  const handleImageError = () => {
    if (imgSrc && !imgSrc.includes('wsrv.nl')) {
      const proxyUrl = `https://wsrv.nl/?url=${encodeURIComponent(product.image)}&output=png`;
      setImgSrc(proxyUrl);
    } else {
      setHasError(true);
    }
  };

  return (
    <Link to={`/product/${product.id}`} style={{ textDecoration: 'none', display: 'block', position: 'relative', ...style }}>
      <div className="product-card-wrapper">
        <div className="product-card-inner">
          
          <div className="card-image-container">
            {!hasError && imgSrc ? (
              <img 
                src={imgSrc} 
                alt={product.name} 
                onError={handleImageError}
                loading="lazy"
                referrerPolicy="no-referrer"
                crossOrigin="anonymous" 
              />
            ) : (
              <div className="fallback-image">
                 <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#444" strokeWidth="1.5">
                    <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="9" y1="15" x2="15" y2="15" />
                 </svg>
                 <span style={{fontSize:'0.7rem', marginTop:'10px', color:'#555', letterSpacing:'2px'}}>NO ASSET</span>
              </div>
            )}
          </div>
          
          <div className="card-info-hover">
             <div className="card-title">{product.name}</div>
             
             {/* */}
             <div style={{color: 'var(--blood-red)', fontWeight: 'bold', marginBottom: '5px', fontSize: '0.9rem'}}>
                {product.price || 'N/A'}
             </div>

             <div className="card-id-badge">ID: {product.sku}</div>
          </div>

        </div>
      </div>
    </Link>
  );
};

export default ProductCard;